import React, { useEffect } from 'react';
import { getFramework, useIdentity } from '@/framework';
import type { ContextMenuPlugin } from '@/plugins/context-menu';
import { PluginType, type IExportPlugin } from '@/version-types';
import { LayerHotkeyType } from '../../type';
import { layerAlignCanvasItem } from './layer-align-canvas-item';
import { layerCloneItem } from './layer-clone-item';
import { layerDeleteItem } from './layer-delete-item';
import { layerFlipItem } from './layer-flip-item';
import { layerLockItem } from './layer-lock-item';
import { layerOverlapItem } from './layer-overlap-item';
import { layerSortItem } from './layer-sort-item';

const LayerContentMenuView: React.FC = React.memo(() => {
    const identity = useIdentity();

    useEffect(() => {
        const framework = getFramework(identity);
        framework.service.registration.getInstance<ContextMenuPlugin>('ContextMenuPlugin').addContextMenu([
            {
                key: LayerHotkeyType.CLONE,
                group: 1,
                sort: 7,
                render: layerCloneItem,
            },
            {
                key: LayerHotkeyType.DELETE,
                group: 4,
                sort: 3,
                render: layerDeleteItem,
            },
            {
                key: LayerHotkeyType.LOCK,
                group: 3,
                sort: 4,
                render: layerLockItem,
            },
            {
                key: 'layer-sort',
                group: 3,
                sort: 1,
                render: layerSortItem,
            },
            {
                key: 'flip',
                group: 3,
                sort: 2,
                render: layerFlipItem,
            },
            {
                key: 'layer-overlap',
                group: 3,
                sort: 3,
                render: layerOverlapItem,
            },
            {
                key: 'alignCanvas',
                group: 4,
                sort: 1,
                render: layerAlignCanvasItem,
            },
        ]);
    }, []);

    return null;
});

const exportPlugin: IExportPlugin = {
    type: PluginType.SYSTEM,
    sort: 1,
    name: 'layer-content-menu',
    render() {
        return <LayerContentMenuView />;
    },
};

export default exportPlugin;
